var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Skeleton',{attrs:{"paragraph":_vm.skeleton.paragraph,"active":_vm.skeleton.active}})}
var staticRenderFns = []

export { render, staticRenderFns }